// ABOUTME: Badge component for status indicators — tone-based, with the legacy Flowbite colour API
// ABOUTME: Supports tones, sizes, and an optional icon

import * as React from "react"
import { cn } from "@shared/lib/utils"
import { badgeVariants } from "./CBadge.variants"
import { TONE_CLASS, type CTone } from "./tone"

type FlowbiteColor =
  | "info"
  | "gray"
  | "failure"
  | "success"
  | "warning"
  | "indigo"
  | "purple"
  | "pink"
  | "blue"
  | "cyan"
  | "dark"
  | "light"
  | "green"
  | "lime"
  | "red"
  | "teal"
  | "yellow"

export interface CBadgeProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "color"> {
  /** Preferred API: the status tone, shared with CInfoBlock. */
  tone?: CTone
  /** Legacy colour API, kept for existing call sites; maps onto a tone. */
  color?: FlowbiteColor
  size?: "xs" | "sm"
  icon?: React.ComponentType<{ className?: string }>
}

/** Everything the old colour API accepted, folded onto the six tones. */
const colorToTone: Record<FlowbiteColor, CTone> = {
  info: "info",
  blue: "info",
  indigo: "info",
  purple: "info",
  pink: "info",
  cyan: "info",
  teal: "success",
  lime: "success",
  green: "success",
  success: "success",
  warning: "warning",
  yellow: "warning",
  failure: "danger",
  red: "danger",
  dark: "dark",
  gray: "neutral",
  light: "neutral",
}

export const CBadge: React.FC<CBadgeProps> = ({
  className,
  tone,
  color = "info",
  size = "xs",
  icon: Icon,
  children,
  ...props
}) => {
  const sizeClasses = size === "xs" ? "text-xs px-2 py-0.5" : "text-sm px-2.5 py-0.5"

  return (
    <div
      className={cn(badgeVariants(), TONE_CLASS[tone ?? colorToTone[color]], sizeClasses, className)}
      {...props}
    >
      {Icon && <Icon className="mr-1 h-3 w-3" />}
      {children}
    </div>
  )
}
